import { render, staticRenderFns } from "./RadioSelection.vue?vue&type=template&id=d6a8f71a&scoped=true"
import script from "./RadioSelection.vue?vue&type=script&lang=js"
export * from "./RadioSelection.vue?vue&type=script&lang=js"
import style0 from "./RadioSelection.vue?vue&type=style&index=0&id=d6a8f71a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6a8f71a",
  null
  
)

export default component.exports